import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { map } from 'rxjs';
import { EntityService } from 'src/app/admin/core/services/entity.service';
import { HttpclientService } from 'src/app/admin/core/services/httpclientService';
import { NavOption } from 'src/app/user/navs/header-user/header-user.component';
import { environment } from 'src/environments/environment';

enum Role {
    Partner = 'Extranet - Adhérent',
    Supplier = 'Extranet - Fournisseur',
}

export class RestrictionEntite {
    entite: string;
    label: string;
    isDynamic: boolean;
}

@Component({
    selector: 'app-restrictions',
    templateUrl: './restrictions.component.html',
    styleUrls: ['./restrictions.component.css'],
})
export class RestrictionsComponent implements OnInit {
    menu: any = [];
    champs: any = [];
    fonctions: any = [];
    fonctionsIronside: any = [
        /*  {
            ref: 'export-fournisseurs-tarifs',
            title: 'Export fournisseurs: Tarifs',
        },
        {
            ref: 'export-fournisseurs-articles',
            title: 'Export fournisseurs: Articles',
        },
        {
            ref: 'export-fournisseurs',
            title: 'Export de la liste des fournisseurs',
        },
        {
            ref: 'export-images',
            title: 'Exportation des images',
        },
        {
            ref: 'document-fournisseurs',
            title: 'Voir les pièces jointes des fournisseurs',
        },
        {
            ref: 'export-adhérents',
            title: 'Export des adhérents',
        },
        {
            ref: 'gestion-articles',
            title: 'Segmentation catalogue',
        },
        {
            ref: 'gestion-marques',
            title: 'Gestion de la fiche adhérent',
        },
        {
            ref: 'gestion-fournisseurs',
            title: 'Gestion des clients Prospects',
        },
        {
            ref: 'catalogue-tarifs',
            title: 'Affichage des tarifs dans le catalogue',
        },
        {
            ref: 'comparateur-produit',
            title: 'Comparateur produit',
        },
        {
            ref: 'accueil-yellow-focus',
            title: 'Yellow Focus - Accueil',
        },
        {
            ref: 'favoris',
            title: 'Favoris',
        },
        {
            ref: 'export-excel-produits',
            title: 'Export Excel produits',
        },

        //Permission Resource Supplier Detail
        {
            ref: 'resource-supplier-detail',
            title: 'Ressources détaillées sur les fournisseurs',
        },

        //Permission show price
        {
            ref: 'visibilite-tarifs',
            title: 'Extranet : afficher les prix',
        },

        //Permission export data
        {
            ref: 'export-data',
            title: `Limites d'exportation de données`,
        },

        //PermissionResource download limit
        {
            ref: 'authorized-resource',
            title: `Limites des ressources`,
        }, */

        { ref: 'yellow-focus-home', title: 'Yellow Focus - Accueil' }, //done
        { ref: 'comparateur-produit', title: 'Comparateur produit' }, //done
        { ref: 'favoris', title: 'Favoris' }, //done
        {
            ref: 'access-ressource-fournisseur',
            title: 'Accès au ressources de la fiche fournisseurs',
        },
        { ref: 'export-excel-logistique', title: 'Export Excel des données logistiques' },
        { ref: 'export-excel-prix', title: 'Export Excel des prix' },
        { ref: 'export-catalogue-logistique', title: 'Export du catalogue Logistique' },
        { ref: 'export-catalogue-sans-prix', title: 'Export du catalogue sans prix PDF' },
        { ref: 'export-catalogue-avec-prix', title: 'Export du catalogue avec prix PDF' },
        { ref: 'export-ressource-videos', title: 'Export ressources vidéos' },
        { ref: 'export-rapport-essais', title: 'Export ressources rapports d’essais' },
        {
            ref: 'export-ressource-pieces-detachees',
            title: 'Export ressources liste pièces détachées',
        },
        { ref: 'export-certificats-sociaux', title: 'Export ressources certificats sociaux' },
        { ref: 'export-engagement-reach', title: 'Export ressources engagements reach' },
        { ref: 'export-photos-hd', title: 'Export ressources photos HD' },
        { ref: 'export-photos-bd', title: 'Export ressources photos BD' },
        {
            ref: 'export-autres-infos-techniques',
            title: 'Export ressources autres informations techniques',
        },
        {
            ref: 'export-autres-infos-produits',
            title: 'Export resssources autres informations produits',
        },
        { ref: 'export-certificat-ironside', title: 'Export ressources certificats ironside' },
        { ref: 'export-certificat-usine', title: 'Export ressources certificats d’usine' },
        { ref: 'export-vues-eclatees', title: 'Export ressources vues éclatées' },
        {
            ref: 'export-certificat-environnement',
            title: 'Export ressources certificats environnementaux',
        },
        { ref: 'export-fiches-techniques', title: 'Export ressources fiches techniques' },
        {
            ref: 'export-informations-commerciales',
            title: 'Export ressources informations commerciales',
        },
        { ref: 'export-oeuvres-art', title: 'Export ressources oeuvres d’art' },
        { ref: 'export-instruction-manual', title: 'Export ressources manuel d’instruction' },
        { ref: 'export-services-apres-vente', title: 'Export ressources services après-vente' },
        { ref: 'visibilite-tarifs', title: 'Visibilité des tarifs dans l’extranet' },
        { ref: 'export-donnees-fournisseurs', title: 'Export données fournisseurs' },
        { ref: 'export-donnees-partenaires', title: 'Export données partenaires' },
    ];

    fonctionsAdisco: any = [
        {
            ref: 'export-fournisseurs-tarifs',
            title: 'Export fournisseurs: Tarifs',
        },
        {
            ref: 'export-fournisseurs-articles',
            title: 'Export fournisseurs: Articles',
        },
        {
            ref: 'export-fournisseurs',
            title: 'Export de la liste des fournisseurs',
        },
        {
            ref: 'document-fournisseurs',
            title: 'Voir les pièces jointes des fournisseurs',
        },
        {
            ref: 'export-adhérents',
            title: 'Export des adhérents',
        },
        {
            ref: 'gestion-articles',
            title: 'Segmentation catalogue',
        },
        {
            ref: 'gestion-marques',
            title: 'Gestion de la fiche adhérent',
        },
        {
            ref: 'gestion-fournisseurs',
            title: 'Gestion des clients Prospects',
        },
        {
            ref: 'catalogue-tarifs',
            title: 'Affichage des tarifs dans le catalogue',
        },
        {
            ref: 'comparateur-produit',
            title: 'Comparateur produit',
        },
    ];

    public fonctionsback: any = [
        'Lecture/Affichage dans le menu',
        'Création',
        'Modification',
        'Suppression unitaire',
        'Modifier le template',
        'Génération de PDF',
        'Filtre dans le tableau de visualisation',
        'Suppression en masse',
        'Recherche par mots clés',
        'Import',
        'Export',
        'Visualisation de fiches en masse',
        'Création/Modification de visualisation',
        'Suppression de visualisation',
    ];
    entites: RestrictionEntite[] = [
        { entite: 'produit', label: 'Produit', isDynamic: false },
        {
            entite: 'personnemorale',
            label: 'Personne morale (fournisseur, associé)',
            isDynamic: false,
        },
        { entite: 'actualite', label: 'Actualité', isDynamic: false },
        { entite: 'personnephysique', label: 'Personne physique (contact)', isDynamic: false },
        { entite: 'role', label: 'Rôle & profil', isDynamic: false },
        { entite: 'categorie', label: 'Catégorie', isDynamic: false },
    ];
    selectedEntity = this.entites[0];

    get restrictions() {
        return this.data.restrict;
    }

    get user() {
        return this.data.user;
    }

    get back() {
        return this.data.back;
    }

    get name() {
        return this.user.firstname
            ? `${this.user.firstname} ${this.user.lastname}`
            : `${this.user.name}`;
    }

    get message() {
        return `Les éléments en surbrillance sont affichés pour ${
            this.user.firstname ? 'cet utilisateur' : 'ce profil'
        }`;
    }

    constructor(
        @Inject(MAT_DIALOG_DATA) public data: any,
        private http: HttpclientService,
        private entiteService: EntityService,
        private dialogRef: MatDialogRef<RestrictionsComponent>
    ) {}

    ngOnInit(): void {
        if (environment.client === 'adisco') {
            this.fonctions = this.fonctionsAdisco;
        } else {
            this.fonctions = this.fonctionsIronside;
        }
        this.loadExistingResources();
    }

    loadExistingResources() {
        if (this.back) this.loadRestrictionsBack();
        else this.loadRestrictionsExtranet();
        this.loadEntite();
    }

    loadRestrictionsBack() {
        let menuUrl = `assets/mock-apis/menu-${environment.client}.json`;
        this.http
            .get<NavOption[]>(menuUrl)
            .pipe(
                map((res) => {
                    this.menu = this.menu.concat(res);
                    this.getAllText();
                })
            )
            .subscribe();
    }

    loadRestrictionsExtranet() {
        let menuUrl = `assets/mock-apis/extranet-menu-${environment.client}.json`;
        this.http
            .get<NavOption[]>(menuUrl)
            .pipe(
                map((res) => {
                    let resCont;
                    if (this.data.user.nom === Role.Partner) {
                        resCont = res.partner;
                    }
                    if (this.data.user.nom === Role.Supplier) {
                        resCont = res.supplier;
                    } else {
                        resCont = res.partner;
                    }

                    this.menu = this.menu.concat(resCont ?? []);
                    this.http
                        .get<NavOption[]>(
                            `assets/mock-apis/extranet-header-${environment.client}.json`
                        )
                        .pipe(
                            map((res) => {
                                this.menu = this.menu.concat(res);

                                this.getAllRef();
                            })
                        )
                        .subscribe();
                })
            )
            .subscribe();
    }

    // loadEntite() {
    //   this.entiteService.recouperChampsdEntite(this.selectedEntity).pipe(
    //     map((res) => {
    //       if (res)
    //         this.champs = res;
    //       this.entiteService.setReqMap(this.selectedEntity, res);
    //     }),
    //     catchError((err) => {
    //       this.champs = [];
    //       throw err;
    //     })
    //   ).subscribe();
    // }

    async loadEntite() {
        if (this.selectedEntity) {
            try {
                const res = await this.entiteService.recouperChampsdEntite(
                    this.selectedEntity.entite
                );
                if (res) {
                    this.champs = res;
                    this.entiteService.setReqMap(this.selectedEntity.entite, res);
                }
            } catch (error) {
                this.champs = [];
                throw error;
            }
        } else {
            this.champs = [];
        }
    }
    getAllRef() {
        this.menu.forEach((el: any) => {
            if (el?.subMenu) this.menu = this.menu.concat(el.subMenu);
        });

        this.menu = this.menu.filter((el: any) => el.ref);
    }
    getAllText() {
        this.menu.forEach((el: any) => {
            if (el?.children) this.menu = this.menu.concat(el.children);
        });

        this.menu = this.menu.map((el: any) => el.text);
    }

    isIn(element: 'menu' | 'champs' | 'fonctions', ref: string): boolean {
        if (element == 'champs') ref = `${this.selectedEntity.entite}:${ref}`;
        return this.restrictions[element].includes(ref);
    }

    select(element: 'menu' | 'champs' | 'fonctions', ref: string) {
        let reff = element == 'champs' ? `${this.selectedEntity.entite}:${ref}` : ref;

        if (this.isIn(element, ref)) {
            this.restrictions[element] = this.restrictions[element].filter((el: any) => el != reff);
        } else {
            this.restrictions[element].push(reff);
        }
    }

    save() {
        this.dialogRef.close('save');
    }
}
